import { z } from "zod";

/**
 * Sync metadata attached to every domain row.
 * Mirrored in Prisma (server) and in the local SQLite schema (`packages/sync`).
 *
 * - `id`: uuid string, generated client-side so offline writes are stable.
 * - `orgId`: organization scope; required for multi-tenant queries + RLS.
 * - `rev`: server-assigned monotonic revision. Null until first sync.
 * - `updatedAt`: ISO timestamp from the writer; used as LWW tie-breaker.
 * - `deletedAt`: tombstone. Rows are never hard-deleted on the client.
 * - `clientId`: device that produced the last write.
 */
export const syncMetaSchema = z.object({
  id: z.string().uuid(),
  orgId: z.string().uuid(),
  rev: z.number().int().nonnegative().nullable(),
  updatedAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable(),
  clientId: z.string().uuid().nullable(),
});
export type SyncMeta = z.infer<typeof syncMetaSchema>;
